import React from 'react';
import cn from 'classnames';
export default (props) => (
  <small className={cn("copyright", props.className)}>© Tour-360, 2013–{(new Date()).getFullYear()}</small>
)
